<style lang="scss">
$leftWidth: 220px;
.goods-check-page {
  .el-form-item__content, .el-form-item__label {
    line-height: 24px !important;
  }

  .el-form-item__label {
    line-height: 24px !important;
  }

  .content-part {
    .el-form-item {
      margin-bottom: 0px;

      &__label {
        line-height: 24px;
      }
    }

    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .level-pic {
    margin-top: 16px;
    margin-left: 40px;
    margin-right: 20px;
    margin-bottom: 16px;
    background: #eee;
    min-height: 160px;
    padding-top: 40px;
    position: relative;

    &-li {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &-title {
      line-height: 22px;
      padding-left: 12px;
    }
  }

  .level-table {
    margin-right: 20px;
    margin-left: 40px;

    .el-input__inner {
      height: 22px;
    }
  }
}
</style>
<template>
  <div class="goods-check-page">
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>查看</h3>
        <div v-if="form">
          <form-show-part :pageSetsItem="pageSets[6]" :currentTab="currentTab">
            <el-form ref="form" :model="form" slot="content"
                     label-width="100px" style="padding-right: 20px">
              <el-form-item style="line-height: 24px !important;" label="操作单位" prop="orgName">
                {{ form.orgName }}
              </el-form-item>
              <el-form-item style="line-height: 24px !important;" label="创建时间" prop="createTime">
                {{ form.createTime | time }}
              </el-form-item>
              <el-form-item label="操作人" prop="creatorName">
                {{ form.creatorName }}
              </el-form-item>
              <el-form-item label="状态" prop="taskStatus" v-if="">
                {{ this.$parent.$parent.stateOptions.find(f => f.value === form.taskStatus) && this.$parent.$parent.stateOptions.find(f => f.value === form.taskStatus).label || '' }}
              </el-form-item>
            </el-form>
          </form-show-part>
        </div>

        <div>
          <form-show-part :pageSetsItem="pageSets[0]" :currentTab="currentTab">
            <div slot="content" v-if="currentItem && currentItem.id">
              <oms-col :is-show="true" label="货品" :rowSpan="6" :value="currentItem.goodsName"/>
              <oms-col :is-show="true" label="规格" :rowSpan="6" :value="currentItem.specification"/>
              <oms-col :is-show="true" label="生产厂商" :rowSpan="6" :value="currentItem.goodsFactoryName"/>
              <oms-col :is-show="true" label="商品编号" :rowSpan="6" :value="currentItem.goodsTrackNo"/>
              <oms-col :is-show="true" label="批号" :rowSpan="6" class="R"
                       :value="currentItem.batchNumberList && currentItem.batchNumberList.join(',')"/>
              <oms-col :is-show="true" label="操作人" :rowSpan="6" :value="currentItem.createdName" v-if="!isLog"/>
              <oms-col :is-show="true" label="操作单位" :rowSpan="6" :value="currentItem.factoryName"/>
              <oms-col :is-show="true" label="上传单位" :rowSpan="6" :value="currentItem.orgName" v-if="isLog"/>
              <oms-col :is-show="true" label="上传人" :rowSpan="6" :value="currentItem.createdName" v-if="isLog"/>
              <oms-col :is-show="true" :label="isLog ? '上传时间' : '操作时间'" :rowSpan="6"
                       :value="currentItem.createTime | time "/>
            </div>
          </form-show-part>
        </div>

        <form-show-part :pageSetsItem="pageSets[4]" :currentTab="currentTab">
          <div slot="content">
            <div>
              <div style="margin-bottom: 10px;overflow: hidden">
                  <span class="pull-right">
                   <span class="btn-search-toggle open">
                      <single-input v-model="filters.code" placeholder="请输入追溯码搜索" :showFocus="true"
                                    style="width: 200px"/>
                      <i class=" el-icon-t-search"></i>
                   </span>
                  </span>
              </div>
              <retrospect-list :traceCodes="traceCodes" :packageType="packageType"
                               v-loading="loading2"></retrospect-list>
              <div class="text-center" v-show="pager.count>pager.pageSize">
                <el-cu-pagination
                    layout="prev, pager, next"
                    :total="pager.count" :pageSize="pager.pageSize" @current-change="getTraceCodes"
                    :current-page="pager.currentPage">
                </el-cu-pagination>
              </div>
            </div>
          </div>
        </form-show-part>
      </div>
    </div>
  </div>
</template>
<script>
import {http, goodsManage, traceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import platform from "@/components/goods/platform";
import utils from "@/tools/utils";
import RetrospectList from '../retrospect/retrospect-list';

export default {
  props: {
    defaultIndex: Number,
    title: String,
    platform: {
      type: Boolean,
      default: false
    },
    form: Object,
    tabledatas: Array
  },
  mixins: [methodsMixin],
  components: {
    RetrospectList
  },
  data() {
    return {
      currentItem: null,
      isLog: true,
      orgRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      platformRules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        orgId: {required: true, message: '请选择操作单位', trigger: 'change'},
        // batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        batchNumberIdList: {required: true, type: 'array', message: '请选择批号', trigger: 'change'},
        productCode: {required: true, message: '请输入产品编码', trigger: 'change'},
        productSubclassCode: {required: true, message: '请输入子类编码', trigger: 'change'},
        productDosage: {required: true, message: '请输入剂型', trigger: 'change'},
        productSpecification: {required: true, message: '请输入剂型规格', trigger: 'change'},
        productPackingSpecification: {required: true, message: '请输入包装规格', trigger: 'change'},
        productPackingUnit: {required: true, message: '请输入包装单位', trigger: 'change'},
      },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null,

      currentTab: {},
      orderAttachment: [], // 文件列表
      uploadStatus: '', // 解析状态
      results: [], // 解析结果
      traceCodes: [], // 追溯码列表
      filters: {
        code: ''
      },
      pager: {
        currentPage: 1,
        count: 0,
        pageSize: 10
      },
      packageType: utils.packageType,
      loading0: false,
      loading1: false,
      loading2: false
    };
  },
  computed: {
    colorList() {
      return this.$store.state.colorList;
    },
    currentGoods() {
      return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    },
    rules() {
      return this.platform ? this.platformRules : this.orgRules
    },
    pageSets() {
      const tabs = {
        0: {name: '关联关系上传任务信息', key: 0},
        1: {name: '源文件', key: 1},
        2: {name: '错误信息', key: 2},
        3: {name: '解析概况', key: 3},
        4: {name: '未删除追溯码', key: 4},
        6: {name: '关联关系删除任务信息', key: 6}
      };
      if (this.$store.state.permissions.includes('codes-file-bind-share-domain')) {
        tabs[5] = {name: '数据共享域名', key: 5};
      }
      if (!this.errorList.length) delete tabs['2'];
      return tabs;
    },
    errorList() {
      return this.orderAttachment.filter(f => f.fileStatus > 1);
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    },
    filters: {
      handler: function () {
        this.getTraceCodes(1);
      },
      deep: true
    },
    form: {
      handler(val) {
        if (!val) return;
        if (!val.objectId) return;
        this.getTraceCodes(1);
        this.getCurrentItem(val);
      }, immediate: true, deep: true
    }
  },
  methods: {
    clearCurrentItem() {
      this.currentItem = null;
      this.traceCodes = [];
    },
    getCurrentItem(item) {
      traceCode.getDeleteGoodsInfo(item.objectId).then(res => {
        this.currentItem = res.data;
      })
    },
    getTraceCodes(pageNo) {
      if (pageNo === 1) {
        this.pager.count = 0;
      }
      this.pager.currentPage = pageNo;
      let params = Object.assign({
        pageNo: pageNo,
        pageSize: this.pager.pageSize
      }, this.filters);
      this.uploadStatus !== '0' && (this.loading2 = true);
      http.get(`/code/order-no/${this.form.objectId}/trace-code`, {params}).then(res => {
        this.traceCodes = res.data.list;
        if (this.traceCodes.length === this.pager.pageSize) {
          this.pager.count = this.pager.currentPage * this.pager.pageSize + 1;
        }
        this.loading2 = false;
      });
    },
    handleTableAdd() {
    },
    handleTableDelete(scope) {
    },
    handleTableEdit(scope) {
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    goodsChange(val) {
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        model: 0,

        orgId: '',

        productName: '',
        productPackingUnit: '',
        productRemark: '',

        productCode: '',
        productSubclassCode: '',
        productDosage: '',
        productSpecification: '',
        productPackingSpecification: ''
      };
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        this.doing = true;
        if (!this.platform) {
          this.form.orgId = this.$store.state.user.userCompanyAddress;
        }
        if (this.title === '新增') {
          goodsManage.goodsAdd(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        } else {
          goodsManage.goodsEdit(this.form).then(res => {
            this.$emit('refresh', {id: res.data});
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '解析失败'
            });
            this.doing = false;
          });
        }
      });
    }
  }
};
</script>
